import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';
import { GlobalService } from './services/global.service';
import { ToDatabaseProviderPipe } from './pipes/to-database-provider.pipe';
import { AppModule } from '../app.module';
import { AuthGuard } from './guards/auth.guard';
import { DisableControlDirective } from './directives/disable-control.directive';
import { DxLoadIndicatorModule, DxLoadPanelModule } from 'devextreme-angular';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    ToDatabaseProviderPipe
  ],
  declarations: [ToDatabaseProviderPipe, DisableControlDirective]
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [ AuthService, GlobalService, AuthGuard ]
    };
  }
}
